
// Agricultural
import agriImg1 from '../assets/catogory/agricultural/img1.jpg';
import agriImg2 from '../assets/catogory/agricultural/img2.jpg';
import agriImg3 from '../assets/catogory/agricultural/img3.jpg';

// Apartments
import aptImg1 from '../assets/catogory/Apartments/img1.jpg';
import aptImg2 from '../assets/catogory/Apartments/img2.jpg';
import aptImg3 from '../assets/catogory/Apartments/img3.jpg';

// Commercial
import commImg1 from '../assets/catogory/Commercial_Plots/img1.jpg';
import commImg2 from '../assets/catogory/Commercial_Plots/img2.jpg';

// Residential
import resImg1 from '../assets/catogory/Residential_Plots/img1.jpg';
import resImg2 from '../assets/catogory/Residential_Plots/img2.jpg';
import resImg3 from '../assets/catogory/Residential_Plots/img3.jpg';

// Villas
import villaImg1 from '../assets/catogory/Individual_Villas/img1.jpg';
import villaImg2 from '../assets/catogory/Individual_Villas/img2.jpg';
import villaImg3 from '../assets/catogory/Individual_Villas/img3.jpg';

// Rentals
import rentImg1 from '../assets/catogory/rent/img1.jpg';
import rentImg2 from '../assets/catogory/rent/img2.jpg';
import rentImg3 from '../assets/catogory/rent/img3.jpg';

export const propertyData = [
    // Residential Plots
    {
        category: 'Residential Plots',
        image: resImg1,
        badgeSale: 'For Sale',
        badgeType: 'Residential Plots',
        features: ['from 2 cents', 'All', 'Yes'],
        title: 'Zetta Gardenia, Periyanaickenpalayam',
        location: 'Periyanaickenpalayam',
        price: 'Call for Price',
        isCallPrice: true
    },
    {
        category: 'Residential Plots',
        image: resImg2,
        badgeSale: 'For Sale',
        badgeType: 'Residential Plots',
        features: ['200 acres', 'All', 'Yes'],
        title: 'Karthipuram, Coimbatore',
        location: 'Neelambur',
        price: 'Call for Price',
        isCallPrice: true
    },
    {
        category: 'Residential Plots',
        image: resImg3,
        badgeSale: 'For Sale',
        badgeType: 'Residential Plots',
        features: ['1.5 - 7 Cents', 'North East', 'Yes'],
        title: 'Brooks Cliff Annur',
        location: 'Periyaputhur',
        price: '5.99 L / Cent',
        isCallPrice: false
    },
    // Individual Villas
    {
        category: 'Individual Villas',
        image: villaImg1,
        badgeSale: 'For Sale',
        badgeType: 'Individual Villas',
        features: ['3 BHK', '2500 sqft', 'Yes'],
        title: 'Premium Villa, Saravanampatti',
        location: 'Saravanampatti',
        price: '1.2 Cr',
        isCallPrice: false
    },
    {
        category: 'Individual Villas',
        image: villaImg2,
        badgeSale: 'For Sale',
        badgeType: 'Individual Villas',
        features: ['4 BHK', '3200 sqft', 'Yes'],
        title: 'Modern Villa, Vadavalli',
        location: 'Vadavalli',
        price: 'Call for Price',
        isCallPrice: true
    },
    {
        category: 'Individual Villas',
        image: villaImg3,
        badgeSale: 'For Sale',
        badgeType: 'Individual Villas',
        features: ['3 BHK', '2800 sqft', 'Yes'],
        title: 'Garden Villa, Thudiyalur',
        location: 'Thudiyalur',
        price: '95 L',
        isCallPrice: false
    },
    // Apartments
    {
        category: 'Apartments',
        image: aptImg1,
        badgeSale: 'For Sale',
        badgeType: 'Apartments',
        features: ['2 BHK', '1200 sqft', 'Yes'],
        title: 'Sky View Apartments, RS Puram',
        location: 'RS Puram',
        price: '65 L',
        isCallPrice: false
    },
    {
        category: 'Apartments',
        image: aptImg2,
        badgeSale: 'For Sale',
        badgeType: 'Apartments',
        features: ['3 BHK', '1650 sqft', 'Yes'],
        title: 'Green Park Residency, Gandhipuram',
        location: 'Gandhipuram',
        price: '85 L',
        isCallPrice: false
    },
    {
        category: 'Apartments',
        image: aptImg3,
        badgeSale: 'For Sale',
        badgeType: 'Apartments',
        features: ['2 BHK', '1100 sqft', 'Yes'],
        title: 'Urban Heights, Peelamedu',
        location: 'Peelamedu',
        price: 'Call for Price',
        isCallPrice: true
    },
    // Commercial Plots
    {
        category: 'Commercial Plots',
        image: commImg1,
        badgeSale: 'For Sale',
        badgeType: 'Commercial Plots',
        features: ['5000 sqft', 'Main Road', 'Yes'],
        title: 'Prime Commercial Plot, Avinashi Road',
        location: 'Avinashi Road',
        price: '2.5 Cr',
        isCallPrice: false
    },
    {
        category: 'Commercial Plots',
        image: commImg2,
        badgeSale: 'For Sale',
        badgeType: 'Commercial Plots',
        features: ['3500 sqft', 'Corner', 'Yes'],
        title: 'Business Hub Plot, Trichy Road',
        location: 'Trichy Road',
        price: 'Call for Price',
        isCallPrice: true
    },
    {
        category: 'Commercial Plots',
        image: commImg2, // Reusing img2 as per previous fix
        badgeSale: 'For Sale',
        badgeType: 'Commercial Plots',
        features: ['2000 sqft', 'Highway', 'Yes'],
        title: 'Highway Commercial, Sathy Road',
        location: 'Sathy Road',
        price: '1.8 Cr',
        isCallPrice: false
    },
    // Agriculture Lands
    {
        category: 'Agriculture Lands', // Note: name in Filter might be 'Agricultural Lands' in some places, checking LatestProperties used 'Agriculture Lands'
        image: agriImg1,
        badgeSale: 'For Sale',
        badgeType: 'Agriculture Lands',
        features: ['5 Acres', 'Water', 'Yes'],
        title: 'Fertile Farm Land, Pollachi',
        location: 'Pollachi',
        price: '50 L / Acre',
        isCallPrice: false
    },
    {
        category: 'Agriculture Lands',
        image: agriImg2,
        badgeSale: 'For Sale',
        badgeType: 'Agriculture Lands',
        features: ['10 Acres', 'Bore Well', 'Yes'],
        title: 'Coconut Farm, Mettupalayam',
        location: 'Mettupalayam',
        price: 'Call for Price',
        isCallPrice: true
    },
    {
        category: 'Agriculture Lands',
        image: agriImg3,
        badgeSale: 'For Sale',
        badgeType: 'Agriculture Lands',
        features: ['3 Acres', 'River Side', 'Yes'],
        title: 'Organic Farm, Anamalai',
        location: 'Anamalai',
        price: '35 L / Acre',
        isCallPrice: false
    },
    // Rentals (using placeholders for now as I don't recall seeing images for them in the file list)
    {
        category: 'Rentals',
        image: rentImg1,
        badgeSale: 'For Rent',
        badgeType: 'Rentals',
        features: ['2 BHK', '1000 sqft', 'Semi-Furnished'],
        title: 'Cozy Apartment, Singanallur',
        location: 'Singanallur',
        price: '15,000 / Month',
        isCallPrice: false
    },
    {
        category: 'Rentals',
        image: rentImg2,
        badgeSale: 'For Rent',
        badgeType: 'Rentals',
        features: ['3 BHK', '1800 sqft', 'Fully-Furnished'],
        title: 'Luxury Villa Rent, Hopes',
        location: 'Hopes College',
        price: '35,000 / Month',
        isCallPrice: false
    },
    {
        category: 'Rentals',
        image: rentImg3,
        badgeSale: 'For Rent',
        badgeType: 'Rentals',
        features: ['1 BHK', '650 sqft', 'Unfurnished'],
        title: 'Budget Flat, Ganapathy',
        location: 'Ganapathy',
        price: '8,000 / Month',
        isCallPrice: false
    }
];
